import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";
import { AuthShell, inputClass } from "./Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Reset password" subtitle="We'll email you a link">
      {sent ? (
        <div className="text-center space-y-4">
          <div className="w-14 h-14 rounded-full bg-emerald-500/15 flex items-center justify-center mx-auto">
            <MailCheck className="w-7 h-7 text-emerald-400" />
          </div>
          <p className="text-slate-300 text-sm leading-relaxed">
            If that email is registered, a reset link has been sent. Check your inbox and spam folder.
          </p>
          <Link to="/login" className="inline-flex items-center gap-2 text-blue-500 hover:text-blue-400 text-sm">
            <ArrowLeft className="w-4 h-4" /> Back to sign in
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          {error && (
            <div className="text-sm text-red-400 bg-red-950/40 border border-red-900/60 rounded-lg px-3 py-2">
              {error}
            </div>
          )}
          <div>
            <label className="text-xs text-slate-400 mb-1.5 block">Email</label>
            <input
              data-testid="forgot-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className={inputClass}
            />
          </div>
          <button
            data-testid="forgot-submit-button"
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-500 text-white font-semibold rounded-xl py-3 flex items-center justify-center transition-colors disabled:opacity-60"
          >
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Send reset link"}
          </button>
          <Link to="/login" className="flex items-center justify-center gap-2 text-slate-400 hover:text-slate-200 text-sm pt-2">
            <ArrowLeft className="w-4 h-4" /> Back to sign in
          </Link>
        </form>
      )}
    </AuthShell>
  );
}
